import {
    takeEvery, all, put, call,
} from 'redux-saga/effects';
import API from '../common/API';
import * as Actions from '../actions/RegistrationViewer';

function* getInformationXPAND(action) {
    const endpoint = action.payload?.language
        ? `/api/v1/event/${action.payload.shortName}/info/?language=${action.payload.language}`
        : `/api/v1/event/${action.payload}/info/`;
    try {
        const response = yield call(API.get, {
            endpoint: `${endpoint}`,
        });
        yield put(Actions.callApiGetInformationXPANDReceived(response));
    } catch (error) {
        yield put(Actions.callApiGetInformationXPANDReceivedFailure(yield error));
    }
}

function* createViewer(action) {
    const endpoint = action.payload?.language
        ? `/api/v1/user/viewer_register/?language=${action.payload.language}`
        : '/api/v1/user/viewer_register/';
    try {
        yield call(API.post, {
            endpoint: `${endpoint}`,
            body: action.payload,
        });
        yield put(Actions.callApiCreateViewerReceived());
    } catch (error) {
        yield put(Actions.callApiCreateViewerReceivedFailure(yield error));
    }
}

export default function* viewer() {
    yield all([
        takeEvery('CALL_API_GET_INFORMATION_XPAND_VIEWER', getInformationXPAND),
        takeEvery('CALL_API_CREATE_VIEWER', createViewer),
    ]);
}
